module.exports = __webpack_public_path__ + "image-68dc09819c0c.png";